import { useEffect } from "react";
import { useSnackbar } from "notistack";

let enqueueSnackbarRef = null;

const SnackbarUtils = {
  setEnqueueSnackbar(enqueueSnackbar) {
    enqueueSnackbarRef = enqueueSnackbar;
  },

  enqueue(message, options) {
    if (enqueueSnackbarRef) {
      enqueueSnackbarRef(message, options);
    }
  },

  success(message) {
    this.enqueue(message, { variant: "success" });
  },

  error(message) {
    this.enqueue(message, { variant: "error" });
  },

  warning(message) {
    this.enqueue(message, { variant: "warning" });
  },

  info(message) {
    this.enqueue(message, { variant: "info" });
  },
};

export function SnackbarUtilsConfigurator() {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    SnackbarUtils.setEnqueueSnackbar(enqueueSnackbar);

    return () => {
      SnackbarUtils.setEnqueueSnackbar(null);
    };
  }, [enqueueSnackbar]);

  return null;
}

export default SnackbarUtils;
